import {timesheetApi} from '@/services/ServiceInst.js'
export default {
  getPractices(context){
    // make api request here
    if(context.state.practices) {
      console.log("practices already there")
    } else {
      timesheetApi.getPractices().then(practices => {
        // console.log("Setting practices")
        context.commit('setPractices', practices)
      })
    }
  },
}